import React, { useState } from 'react';
import {
  TextField,
  Switch,
  FormControlLabel,
  Button,
  Box,
  Typography,
} from '@mui/material';
import dayjs from "dayjs";
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import { SetActivityCreate } from '../../Conections/AcademicConection';
import BasicDatePicker from '../../components/DataPicker';

const ActivityCreate = () => {

  const goTo = useNavigate();
  const { getToken, getCompany } = useAuth();
  const params = useParams();

  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    peso: '', // Added peso field
    show: false
  });

  const [value, setValue] = React.useState(dayjs());

  React.useEffect(() => {
    async function reloaduser() {
      if (getToken()) {
        const permisionCan = await can(getToken(), getCompany(), "/academic/createactivity/:group");
        if (permisionCan === 0) {
          goTo("/dashboard");
        }
      }
      else {
        goTo(`/login`);
      }
    };
    reloaduser();
  }, [getCompany, getToken, goTo]);

  

  const handleChange = (event) => {
    const { name, value, checked } = event.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: name === 'show' ? checked : value
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const datos = await SetActivityCreate(
      getToken(),
      getCompany(),
      params["group"],
      (typeof params["activity"]==="undefined")?-1:params["activity"],
      formData.nombre,
      formData.descripcion,
      value["$D"],
      (value["$M"] + 1),
      value["$y"],
      formData.peso,
      formData.show ? 1 : 0
    );
    goTo(`/academic/showactivity/${datos}`);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400, margin: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Crear Nueva Actividad
      </Typography>

      <TextField
        fullWidth
        margin="normal"
        name="nombre"
        label="Nombre"
        value={formData.nombre}
        onChange={handleChange}
        required
      />

      <TextField
        fullWidth
        margin="normal"
        name="descripcion"
        label="Descripción"
        multiline
        rows={4}
        value={formData.descripcion}
        onChange={handleChange}
        required
      />

      <TextField // Added peso field
        fullWidth
        margin="normal"
        name="peso"
        label="Peso"
        type="number"
        value={formData.peso}
        onChange={handleChange}
        required
      />

      <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
        Fecha
      </Typography>
      <BasicDatePicker
        fullWidth
        date={value} 
        setDate={setValue}
        required
      />
      <FormControlLabel
        control={
          <Switch
            checked={formData.show}
            onChange={handleChange}
            name="show"
          />
        }
        label="Mostrar"
        sx={{ mt: 2 }}
      />

      <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
        Crear Actividad
      </Button>
    </Box>
  );
};

export default ActivityCreate;

